import React from 'react';
import classNames from 'classnames';
import GoogleMapReact from 'google-map-react';
import { GOOGLE_MAPS_API_KEY } from '../../config';

const defaultCenter = { lat: 59.3273056, lng: 17.8390038 };
const bootstrapURLKeys = { key: GOOGLE_MAPS_API_KEY, language: 'sv' };
const mapOptions = { fullscreenControl: false };
const hiddenOverlay = { display: 'none' };

const MapContent = React.memo(({
    isLoadingMarkers,
    onGoogleApiLoaded
}) => {
    return (
        <div className={classNames({
            'create-district-map__map': true,
            'create-district-map--is-loading-markers': isLoadingMarkers
        })} style={{ width: "100%", minHeight: '300px' }}>
            <GoogleMapReact
                bootstrapURLKeys={bootstrapURLKeys}
                options={mapOptions}
                defaultZoom={6}
                defaultCenter={defaultCenter}
                yesIWantToUseGoogleMapApiInternals={true}
                overlayViewDivStyle={hiddenOverlay}
                onGoogleApiLoaded={({ map, maps }) => onGoogleApiLoaded(map, maps)}
            />
        </div>
    );
});

export default MapContent; 